<template>
  <div class="app-container">
    <div class="filter-container">
      <el-form :inline="true" label-position="top" label-width="100px" class="custom-form">
        <el-form-item :label="$t('company.companyName')" class="custom-item">
          <el-input
            :placeholder="$t('company.companyName')"
            v-model="listQuery.title"
            class="filter-item"
          />
        </el-form-item>
        <el-form-item :label="$t('company.companyType')" class="custom-item">
          <el-select
            v-model="listQuery.companyType"
            :placeholder="$t('company.companyType')"
            class="filter-item"
          >
            <el-option label="全部" value />
            <el-option
              v-for="item in types"
              :key="item.key"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('table.status')" class="custom-item">
          <el-select
            v-model="listQuery.status"
            :placeholder="$t('table.status')"
            class="filter-item"
          >
            <el-option label="全部" value />
            <el-option
              v-for="(item,index) in statusType"
              :key="index"
              :label="item"
              :value="index"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('company.memberGrade')" class="custom-item">
          <el-select
            v-model="listQuery.memberGradeId"
            :placeholder="$t('company.memberGrade')"
            class="filter-item"
          >
            <el-option label="全部" value />
            <el-option
              v-for="(item,index) in gradeLists"
              :key="index"
              :label="item.gradeName"
              :value="item.gradeId"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="!(emp.groupId === emp.stationId)"
          :label="$t('company.station')"
          class="custom-item"
        >
          <el-select
            v-model="listQuery.optStationId"
            :placeholder="$t('company.station')"
            class="filter-item"
          >
            <el-option v-if="isAllStation === 1" label="全部" value />
            <el-option
              v-for="(item,index) in stationLists"
              :key="index"
              :label="item.stationName"
              :value="item.stationId"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <p style="text-align:center">
        <el-button
          v-waves
          class="filter-item"
          type="primary"
          icon="el-icon-search"
          @click="handleFilter"
        >{{ $t('table.search') }}</el-button>
        <el-button
          class="filter-item"
          style="margin-left: 10px;"
          type="primary"
          icon="el-icon-edit"
          @click="handleCreate"
        >{{ $t('table.add') }}</el-button>
      </p>
    </div>
    <el-row>
      <el-col :offset="18">
        <h3>
          余额：{{ totalBalance }}
          <!--&nbsp;&nbsp;预授权金额：{{ totalFrozen }}-->
        </h3>
      </el-col>
    </el-row>
    <el-table
      v-loading="listLoading"
      :key="tableKey"
      :data="list"
      border
      fit
      highlight-current-row
      style="width: 100%;"
    >
      <el-table-column :label="$t('company.companyId')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.companyId }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('company.companyName')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.companyName }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('company.memberGradeName')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.memberGradeName }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('company.companyType')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.companyType | typeFilter }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('company.optStationName')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.optStationName }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('company.balanceAmt')" align="center" width="100%">
        <template slot-scope="scope">
          <span>{{ scope.row.balanceAmt }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('company.frozenAmt')" align="center" width="80%">
        <template slot-scope="scope">
          <span>{{ scope.row.frozenAmt }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('company.creditAmt')" align="center" width="120%">
        <template slot-scope="scope">
          <span>{{ scope.row.creditAmt }}</span>
        </template>
      </el-table-column>
      <!--      <el-table-column :label="$t('company.point')" align="center" width="120%">
        <template slot-scope="scope">
          <span>{{ scope.row.point }}</span>
        </template>
      </el-table-column>-->
      <el-table-column :label="$t('grade.status')" align="center" width="120%">
        <template slot-scope="scope">
          <span>{{ scope.row.status | statusFilter }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('company.createdTime')" align="center" min-width="160px">
        <template slot-scope="scope">
          <span>{{ scope.row.createdTime }}</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('table.actions')"
        width="180px"
        align="center"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-row>
            <el-col :span="12">
              <el-dropdown :hide-on-click="false">
                <span class="el-dropdown-link" style="padding:0px 10px">
                  查询
                  <i class="el-icon-arrow-down el-icon--right" />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <span style="display:block;" @click="redirectPage('amount',scope.row)">资金明细</span>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <span style="display:block;" @click="redirectPage('fuel',scope.row)">加油记录</span>
                  </el-dropdown-item>
                  <!--                  <el-dropdown-item>
                    <span style="display:block;" @click="redirectPage('point',scope.row)">积分记录</span>
                  </el-dropdown-item>-->
                  <el-dropdown-item>
                    <span style="display:block;" @click="showMembers(scope.row)">子帐户列表</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-col>
            <el-col :span="12">
              <el-dropdown
                v-if="scope.row.status!=-1"
                :hide-on-click="false"
                style="margin-left:5px"
              >
                <span class="el-dropdown-link" style="padding:0px 10px">
                  操作
                  <i class="el-icon-arrow-down el-icon--right" />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <span
                      v-if="scope.row.status==1"
                      style="display:block;"
                      @click="handleModifyStatus(scope.row)"
                    >冻结</span>
                    <span v-else style="display:block;" @click="handleModifyStatus(scope.row)">解冻</span>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <span style="display:block;" @click="handleUpdate(scope.row)">修改资料</span>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <span style="display:block;" @click="handleCharge(scope.row)">车队充值</span>
                  </el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.companyType === 2">
                    <span style="display:block;" @click="handleTransfer(scope.row)">向个人转账</span>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <span style="display:block;" @click="handleRefund(scope.row)">车队退款</span>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <span style="display:block;" @click="redirectPage('member',scope.row)">新增子帐户</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-col>
          </el-row>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10,20,30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog
      v-if="dialogFormVisible"
      :title="textMap[dialogStatus]"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="600px"
    >
      <el-form
        ref="dataForm"
        :rules="rules"
        :model="temp"
        label-position="right"
        label-width="100px"
        style="margin-right:30px;"
      >
        <el-form-item label="车队名称" prop="companyName">
          <el-input
            v-model="temp.companyName"
            :disabled="((temp.companyId > 0)) ? true : false"
            maxlength="30"
          />
        </el-form-item>
        <el-form-item :label="$t('company.contactName')" prop="contactName">
          <el-input v-model="temp.contactName" maxlength="20" />
        </el-form-item>
        <el-form-item :label="$t('company.contactPhone')" prop="contactPhone">
          <el-input v-model="temp.contactPhone" minlength="8" maxlength="20" />
        </el-form-item>
        <el-form-item label="登录账号" prop="loginName">
          <el-input
            v-model="temp.loginName"
            :disabled="loginNameStatus"
            auto-complete="off"
            minlength="2"
            maxlength="20"
          />
        </el-form-item>
        <el-form-item label="登录密码" prop="pwd">
          <el-input
            v-model="temp.pwd"
            type="password"
            auto-complete="off"
            minlength="6"
            maxlength="20"
          />
        </el-form-item>
        <el-form-item :label="$t('company.memberGrade')" prop="memberGradeName">
          <el-select
            v-model="temp.memberGradeName"
            class="filter-item"
            placeholder="请选择"
            @change="bindChange"
          >
            <el-option
              v-for="(item,index) in gradeLists"
              :key="index"
              :label="item.gradeName"
              :value="index"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('company.companyType')" prop="companyType">
          <el-select
            v-model="temp.companyType"
            :disabled="(temp.companyId && temp.companyId>=0) ? true : false"
            class="filter-item"
            @change="bindChangeType"
          >
            <el-option
              v-for="(item,index) in types"
              :key="index"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('company.creditAmt')" prop="creditAmt">
          <el-input
            v-model.number="temp.creditAmt"
            :disabled="(temp.companyType===2||overdrawAmtAuth()) ? true:false"
            type="number"
            maxlength="8"
          />
        </el-form-item>
        <el-form-item :label="$t('company.address')" prop="address">
          <el-cascader
            v-model="selectedOptions"
            :options="options"
            size="large"
            @change="handleChange"
          />
          <el-input v-model="temp.address" maxlength="50" />
        </el-form-item>
        <el-form-item :label="$t('company.email')" prop="email">
          <el-input v-model="temp.email" maxlength="50" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">{{ $t('table.cancel') }}</el-button>
        <el-button v-if="dialogStatus=='create'" type="primary" @click="createData">确定</el-button>
        <el-button v-else type="primary" @click="updateData">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="dialogPvVisible" title="车队充值" width="600px">
      <el-form
        ref="chargeForm"
        :rules="charageRules"
        :model="charage"
        label-position="right"
        label-width="100px"
        style="margin-right:30px;"
      >
        <el-form-item v-if="charage.companyId" label="车队名称">
          <el-input v-model="charage.companyName" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('company.amt')" prop="amt">
          <el-input v-model.number="charage.amt" type="number" min="1" maxlength="10" />
        </el-form-item>
        <el-form-item :label="$t('company.giftAmt')" prop="giftAmt">
          <el-input v-model.number="charage.giftAmt" type="number" min="0" />
        </el-form-item>
        <el-form-item :label="$t('company.payType')" prop="payTypeId">
          <el-select v-model="charage.payTypeId" class="filter-item" placeholder="请选择">
            <el-option
              v-for="(item,index) in payLists"
              :key="index"
              :label="item.payTypeName"
              :value="item.payTypeId"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('company.memo')" prop="memo">
          <el-input v-model="charage.memo" maxlength="50" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogPvVisible = false">{{ $t('table.cancel') }}</el-button>
        <el-button type="primary" @click="optcharge">{{ $t('table.confirm') }}</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogRefundVisible" title="车队退款" width="600px">
      <el-form
        ref="refundForm"
        :rules="refundRules"
        :model="refund"
        label-position="right"
        label-width="100px"
        style="margin-right:30px;"
      >
        <el-form-item v-if="charage.companyId" label="车队名称">
          <el-input v-model="charage.companyName" :disabled="true" />
        </el-form-item>
        <el-form-item label="退款金额" prop="amt">
          <el-input v-model.number="refund.amt" min="1" />
        </el-form-item>
        <el-form-item :label="$t('company.memo')" prop="memo">
          <el-input v-model="refund.memo" maxlength="50" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogRefundVisible = false">{{ $t('table.cancel') }}</el-button>
        <el-button type="primary" @click="optRefund">{{ $t('table.confirm') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      v-if="dialogAmountVisible"
      :visible.sync="dialogAmountVisible"
      :title="dialogTitle"
      width="1020px"
    >
      <HistoryAmount :company-id="commonParam" :member-id="0" :flag="true" />
    </el-dialog>
    <el-dialog
      v-if="dialogFuelVisible"
      :visible.sync="dialogFuelVisible"
      :title="dialogTitle"
      width="1020px"
    >
      <HistoryFuel :company-id="commonParam" :member-id="0" :flag="true" />
    </el-dialog>
    <el-dialog
      v-if="dialogPointVisible"
      :visible.sync="dialogPointVisible"
      :title="dialogTitle"
      width="1020px"
    >
      <HistoryPoint :company-id="commonParam" :member-id="0" :flag="true" />
    </el-dialog>
    <el-dialog
      v-if="dialogMemberVisible"
      :visible.sync="dialogMemberVisible"
      :title="dialogTitle"
      :close-on-click-modal="false"
      width="900px"
    >
      <NewChildMember
        :company-id="commonParam"
        :company-name="companyName"
        :grade-id="gradeId"
        :flag="true"
        @dialogEmp="changeDialogMemberVisible"
        @createdData="freshData"
      />
    </el-dialog>
    <el-dialog
      v-if="dialogTransfer"
      :visible.sync="dialogTransfer"
      :close-on-click-modal="false"
      title="向个人转账"
      width="850px"
    >
      <el-row type="flex" class="row-bg" justify="center">
        <el-col :span="10">
          <span style="font-size: 18px">总账金额：{{ balanceAmt }}</span>
        </el-col>
        <el-col :span="8">
          <span style="font-size: 18px">剩余可转账金额：{{ transferAmount }}</span>
        </el-col>
      </el-row>
      <br >
      <el-row>
        <el-col>
          <el-form ref="transferForm" :model="transferModel" label-width="90px">
            <el-row type="flex" class="row-bg" justify="center">
              <el-col :span="8">
                <el-form-item label="子帐户一：" prop="childAccount">
                  <el-select
                    v-model="transferModel.childAccount[0]"
                    :clearable="true"
                    placeholder="请选择子账户"
                  >
                    <el-option
                      v-for="(item,index) in memberList"
                      :key="index"
                      :label="item.memberName"
                      :value="item.refAmtAccountId"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="子帐户二：" prop="childAccount">
                  <el-select
                    v-model="transferModel.childAccount[1]"
                    :clearable="true"
                    placeholder="请选择子账户"
                  >
                    <el-option
                      v-for="(item,index) in memberList"
                      :key="index"
                      :label="item.memberName"
                      :value="item.refAmtAccountId"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="子帐户三：" prop="childAccount">
                  <el-select
                    v-model="transferModel.childAccount[2]"
                    :clearable="true"
                    placeholder="请选择子账户"
                  >
                    <el-option
                      v-for="(item,index) in memberList"
                      :key="index"
                      :label="item.memberName"
                      :value="item.refAmtAccountId"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" class="row-bg" justify="center">
              <el-col :span="8">
                <el-form-item label="金额一：" prop="transferMoney">
                  <el-input
                    v-model="inputMoney1"
                    placeholder="请输入金额"
                    min="0.00"
                    step="10.00"
                    @focus="inputMoney1 = ''"
                    @blur="checkTransferMoney"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="金额二：" prop="transferMoney">
                  <el-input
                    v-model="inputMoney2"
                    placeholder="请输入金额"
                    min="0.00"
                    step="10.00"
                    @focus="inputMoney2 = ''"
                    @blur="checkTransferMoney"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="金额三：" prop="transferMoney">
                  <el-input
                    v-model="inputMoney3"
                    placeholder="请输入金额"
                    min="0.00"
                    step="10.00"
                    @focus="inputMoney3 = ''"
                    @blur="checkTransferMoney"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <p v-if="showTips" style="text-align: center;color: red">*请输入正确的金额！</p>
            <p style="text-align: center;color: #C0C0C0">*可最多同时向三个子账户</p>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogTransfer = false">取 消</el-button>
        <el-button type="primary" @click="confirmTransfer">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  fetchList,
  createCompany,
  updateCompany,
  companyFrozen,
  addCharge,
  addRefund,
  fetchTotalCompany
} from '@/api/company'
import { gradeList } from '@/api/grade'
import { listPayType } from '@/api/setting'
import { stationList } from '@/api/station'
import { companyCharge } from '../../../../api/member'
import NewChildMember from '@/components/Record/NewChildMember'
import HistoryFuel from '@/components/Record/HistoryFuel'
import HistoryAmount from '@/components/Record/HistoryAmount'
import HistoryPoint from '@/components/Record/HistoryPoint'
import waves from '@/directive/waves' // 水波纹指令
import createUniqueString from '@/utils/createUniqueString'
import { getEmpInfo, getUserPermissions } from '../../../../utils/auth'
import { isNumber } from '@/utils/validate'
import { provinceAndCityData, CodeToText } from 'element-china-area-data'
import { memberList } from '@/api/member'
import { checkEmpPwd } from '@/api/setting'
const typeOptions = [
  { value: 1, label: '总帐支付' },
  { value: 2, label: '子账支付' }
]
const statusMap = { 0: '冻结', 1: '正常' }
const empinfo = getEmpInfo()
export default {
  name: 'ComplexTable',
  directives: {
    waves
  },
  filters: {
    statusFilter (status) {
      return statusMap[status]
    },
    typeFilter (type) {
      for (const key in typeOptions) {
        if (typeOptions[key].value === type) {
          return typeOptions[key].label
        }
      }
    }
  },
  components: {
    HistoryFuel,
    HistoryAmount,
    HistoryPoint,
    NewChildMember
  },
  data () {
    const checkCreditAmt = (rule, value, callback) => {
      console.log(value)
      console.log(typeof value)
      console.log(value == '')
      console.log(typeof value === 'string')
      if (typeof value === 'string') {
        // this.temp.creditAmt = 0;
        return callback(new Error('输入不合法(默认值为0)'))
      } else {
        if (this.temp.companyType === 3 && value < 0) {
          return callback(new Error('透支额度不能小于0'))
        } else {
          // this.temp.creditAmt = 0
          callback()
        }
      }
    }
    const checkAmt = (rule, value, callback) => {
      console.log(value)
      if (!value) {
        return callback(new Error('金额不能为空'))
      }
      if (!Number.isInteger(value)) {
        callback(new Error('请输入整数金额'))
      } else {
        value = Number.parseFloat(value)
        if (value < 0) {
          callback(new Error('金额必须大于0！'))
        } else if (value > 1000000) {
          callback(new Error('金额必须不能大于1000000！'))
        } else {
          callback()
        }
      }
    }
    const checkNum = (rule, value, callback) => {
      if (value) {
        if (!Number.isInteger(value)) {
          callback(new Error('请输入整数金额'))
        } else {
          value = Number.parseFloat(value)
          if (value < 0) {
            callback(new Error('金额必须大于0！'))
          } else if (value > 9999999) {
            callback(new Error('金额必须不能大于9999999！'))
          } else {
            callback()
          }
        }
      } else {
        callback()
      }
    }
    const checkPhone = (rule, value, callback) => {
      if (!isNumber(value)) {
        callback(new Error('请输入正确电话'))
      } else {
        callback()
      }
    }
    return {
      totalBalance: 0,
      totalFrozen: 0,
      showTips: false,
      options: provinceAndCityData,
      selectedOptions: [],
      balanceAmt: 0,
      inputMoney1: 0,
      inputMoney2: 0,
      inputMoney3: 0,
      transferAmount: 0,
      selectLocation: '',
      emp: empinfo,
      tableKey: 0,
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 20,
        status: '',
        title: '',
        companyType: '',
        memberGradeId: '',
        optStationId:
          getEmpInfo().isAllStation === 0 ? getEmpInfo().stationId : ''
      },
      isAllStation: getEmpInfo().isAllStation,
      transferModel: {
        masterAccount: '',
        childAccount: [],
        transferMoney: []
      },
      showReviewer: false,
      temp: {
        creditAmtDisabled: true,
        companyId: 0,
        companyName: '',
        contactName: '',
        contactPhone: '',
        loginName: '',
        pwd: '',
        memberGradeId: '',
        memberGradeName: '',
        companyType: '',
        creditAmt: 0,
        address: '',
        email: ''
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '添加'
      },
      loginNameStatus: false,
      dialogPvVisible: false,
      dialogRefundVisible: false,
      dialogTransfer: false,
      types: typeOptions,
      statusType: statusMap,
      rules: {
        companyName: [
          { required: true, message: '必须填写', trigger: 'blur' },
          {
            min: 2,
            max: 50,
            message: '长度在 2 到 50 个字符',
            trigger: 'blur'
          }
        ],
        contactName: [
          { required: true, message: '必须填写', trigger: 'blur' },
          {
            min: 2,
            max: 20,
            message: '长度在 2 到 20 个字符',
            trigger: 'blur'
          }
        ],
        contactPhone: [
          { required: true, message: '必须填写', trigger: 'blur' },
          {
            min: 8,
            max: 20,
            message: '长度在 8 到 20 个字符,且为数字',
            trigger: 'blur',
            validator: checkPhone
          }
        ],
        loginName: [
          { required: true, message: '必须填写', trigger: 'blur' },
          {
            min: 2,
            max: 15,
            message: '长度在 2 到 15 个字符',
            trigger: 'blur'
          }
        ],
        pwd: [
          { required: true, message: '必须填写', trigger: 'blur' },
          {
            min: 6,
            max: 20,
            message: '长度在 6 到 20 个字符',
            trigger: 'blur'
          }
        ],
        memberGradeName: [
          { required: true, message: '必须填写', trigger: 'change' }
        ],
        companyType: [
          { required: true, message: '必须填写', trigger: 'change' }
        ],
        creditAmt: [
          { type: 'number', validator: checkCreditAmt, trigger: 'blur' }
        ]
      },
      charageRules: {
        companyId: [{ required: true, message: '必须选择', trigger: 'change' }],
        amt: [
          {
            type: 'number',
            required: true,
            message: '请输入正确数字',
            trigger: 'change',
            min: 1
          },
          { type: 'number', validator: checkAmt, trigger: 'blur' }
        ],
        giftAmt: [{ type: 'number', validator: checkNum, trigger: 'blur' }],
        payTypeId: [{ required: true, message: '必须选择', trigger: 'change' }]
      },
      refundRules: {
        amt: [
          {
            type: 'number',
            required: true,
            message: '请输入正确数字',
            trigger: 'blur',
            min: 1
          },
          { type: 'number', validator: checkNum, trigger: 'blur' }
        ],
        memo: [
          { required: true, message: '必须填写', trigger: 'blur' },
          { min: 2, max: 30, message: '长度在 2 到 30 个字符', trigger: 'blur' }
        ]
      },
      charage: {
        memberId: 0,
        amt: '',
        giftAmt: '',
        payTypeId: '',
        payTypeName: '',
        memo: '',
        companyName: ''
      },
      refund: {
        amt: '',
        memo: ''
      },
      gradeLists: [],
      payLists: [],
      stationLists: [],
      dialogTitle: '',
      commonParam: '',
      companyName: '',
      gradeId: 0,
      dialogFuelVisible: false,
      dialogAmountVisible: false,
      dialogPointVisible: false,
      dialogMemberVisible: false,
      memberList: [],
      transferLegal: false
    }
  },
  created () {
    // 获取选择列表
    gradeList({}).then(response => {
      const row = response.data
      if (row.data) {
        const obj = row.data
        for (const key in obj) {
          this.gradeLists.push({
            gradeId: obj[key].gradeId,
            gradeName: obj[key].gradeName
          })
        }
      }
    })
    listPayType({ status: 1 }).then(response => {
      const row = response.data
      if (row.data) {
        const obj = row.data
        for (const key in obj) {
          if (obj[key].payTypeId === 2) {
            continue
          }
          this.payLists.push({
            payTypeId: obj[key].payTypeId,
            payTypeName: obj[key].payTypeName
          })
        }
      }
    })
    stationList({ ps: 100 }).then(response => {
      const row = response.data
      if (row.data.items) {
        const obj = row.data.items
        for (const key in obj) {
          this.stationLists.push({
            stationId: obj[key].stationId,
            stationName: obj[key].stationName
          })
        }
      }
    })
    this.handleFilter()
  },
  methods: {
    redirectPage (type, row) {
      this.commonParam = row.companyId
      if (type === 'fuel') {
        this.dialogTitle = row.companyName + ' - 加油记录'
        this.dialogFuelVisible = true
      }
      if (type === 'amount') {
        this.dialogTitle = row.companyName + ' - 资金流水'
        this.dialogAmountVisible = true
      }
      if (type === 'point') {
        this.dialogTitle = row.companyName + ' - 积分记录'
        this.dialogPointVisible = true
      }
      if (type === 'member') {
        if (!getUserPermissions('COMPANY_ADD')) {
          this.$notify({
            title: '错误',
            message: '抱歉，你没有权限，请联系管理员开通',
            type: 'error'
          })
          return
        }
        this.companyName = row.companyName
        this.gradeId = row.memberGradeId
        this.dialogTitle = row.companyName + ' - 添加子账户'
        this.dialogMemberVisible = true
      }
    },
    showMembers (row) {
      this.$router.push({
        path: '/customer/company/childMember',
        query: { memberType: 2, companyId: row.companyId }
      })
    },
    handleRefund (row) {
      this.$prompt('请输入您的登录密码：', '提示', {
        inputType: 'password',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /.{6}?/,
        inputErrorMessage: '密码格式不对',
        inputPlaceholder: '请输入密码',
        closeOnClickModal: false
      }).then(({ value }) => {
        checkEmpPwd({ pwd: value }).then(response => {
          if (response.data.code === 0) {
            this.dialogRefundVisible = true
            this.refund.companyId = row.companyId
            this.refund.sourceId = createUniqueString()
            this.refund.amt = ''
            this.refund.memo = ''
            this.$nextTick(() => {
              this.$refs['refundForm'].clearValidate()
            })
          }
        })
      })
    },
    optRefund () {
      this.$refs['refundForm'].validate(valid => {
        if (!valid) return
        addRefund(this.refund).then(res => {
          this.dialogRefundVisible = false
          this.$message({
            message: '退款成功',
            type: 'success'
          })
          this.getList()
        })
      })
    },
    handleCharge (row) {
      if (!getUserPermissions('COMPANY_CHARGE')) {
        this.$notify({
          title: '错误',
          message: '抱歉，你没有权限，请联系管理员开通',
          type: 'error'
        })
        return
      }
      this.$prompt('请输入您的登录密码：', '提示', {
        inputType: 'password',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /.{6}?/,
        inputErrorMessage: '密码格式不对',
        inputPlaceholder: '请输入密码',
        closeOnClickModal: false
      }).then(({ value }) => {
        checkEmpPwd({ pwd: value }).then(response => {
          if (response.data.code === 0) {
            this.charage = {
              memberId: 0,
              amt: '',
              giftAmt: '',
              payTypeId: '',
              payTypeName: '',
              memo: '',
              companyName: row.companyName,
              companyId: row.companyId,
              sourceId: createUniqueString()
            }
            /*      this.charage.companyName = row.companyName
            this.charage.companyId = row.companyId
            this.charage.sourceId = createUniqueString()*/
            this.dialogPvVisible = true
            this.$nextTick(() => {
              this.$refs['chargeForm'].clearValidate()
            })
          }
        })
      })
    },
    handleTransfer (row) {
      this.$prompt('请输入您的登录密码：', '提示', {
        inputType: 'password',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /.{6}?/,
        inputErrorMessage: '密码格式不对',
        inputPlaceholder: '请输入密码',
        closeOnClickModal: false
      }).then(({ value }) => {
        checkEmpPwd({ pwd: value }).then(response => {
          if (response.data.code === 0) {
            this.showTips = false
            this.inputMoney1 = 0
            this.inputMoney2 = 0
            this.inputMoney3 = 0
            this.transferLegal = false
            this.transferModel = {
              masterAccount: '',
              childAccount: [],
              transferMoney: []
            }
            this.balanceAmt = row.balanceAmt
            this.transferAmount = row.balanceAmt
            if (!row.companyId) {
              this.dialogTransfer = false
            }
            this.transferModel.masterAccount = row.refAmtAccountId
            if (!this.transferModel.masterAccount) {
              this.dialogTransfer = false
            }
            const query = {
              memberType: 2,
              companyId: row.companyId,
              pi: 1,
              ps: 10000,
              status: 1
            }
            memberList(query)
              .then(resp => {
                this.memberList = resp.data.data.items
                if (this.memberList.length) {
                  this.dialogTransfer = true
                } else {
                  this.$alert('没有子账户！', '提示', {
                    confirmButtonText: '确定'
                  })
                }
              })
              .catch(error => {
                console.log('转账界面获取会员列表失败')
                console.log(error)
              })
          }
        })
      })
    },
    optcharge () {
      this.$refs['chargeForm'].validate(valid => {
        if (valid) {
          if (this.charage.payTypeId) {
            const obj = this.payLists.find(
              o => o.payTypeId === this.charage.payTypeId
            )
            this.charage.payTypeName = obj.payTypeName
          }
          addCharge(this.charage).then(res => {
            this.dialogPvVisible = false
            this.$message({
              message: '充值成功',
              type: 'success'
            })
            this.getList()
          })
        }
      })
    },
    bindChange (selVal) {
      this.temp.memberGradeId = this.gradeLists[selVal].gradeId
      this.temp.memberGradeName = this.gradeLists[selVal].gradeName
    },
    bindCompanyTypeChange (selVal) {
      this.temp.creditAmtDisabled = selVal === 2
      if (this.temp.creditAmtDisabled) {
        this.temp.creditAmt = 0
      }
    },
    getList () {
      this.listLoading = true
      this.listQuery['pi'] = this.listQuery.page
      this.listQuery['ps'] = this.listQuery.limit
      this.listQuery['companyName'] = this.listQuery.title
      fetchList(this.listQuery).then(response => {
        const row = response.data
        if (row.data) {
          this.list = row.data.items
          this.total = row.data.totalItems
        }
        this.listLoading = false
      })
    },
    handleFilter () {
      fetchTotalCompany(this.listQuery).then(resp => {
        const result = resp.data.data
        if (result) {
          this.totalBalance = result.totalBalance
          this.totalFrozen = result.totalFrozen
        } else {
          this.totalBalance = 0
          this.totalFrozen = 0
        }
      })
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange (val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.listQuery.page = val
      this.getList()
    },
    handleModifyStatus (row) {
      this.$prompt('请输入您的登录密码：', '提示', {
        inputType: 'password',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /.{6}?/,
        inputErrorMessage: '密码格式不对',
        inputPlaceholder: '请输入密码',
        closeOnClickModal: false
      })
        .then(({ value }) => {
          checkEmpPwd({ pwd: value })
            .then(response => {
              if (response.data.code === 0) {
                const flag = row.status ? 0 : 1
                companyFrozen({ companyId: row.companyId, status: flag }).then(
                  res => {
                    row.status = flag
                    this.$message({
                      message: '操作成功',
                      type: 'success'
                    })
                    this.getList()
                  }
                )
              }
            })
            .catch(e => {
              this.$message({
                message: '操作失败',
                type: 'info'
              })
            })
        })
        .catch(() => {
          console.log('取消输入员工密码。time=', new Date())
        })
    },
    resetTemp () {
      this.temp = {
        creditAmtDisabled: true,
        companyId: 0,
        companyName: '',
        contactName: '',
        contactPhone: '',
        loginName: '',
        pwd: '',
        memberGradeId: '',
        memberGradeName: '',
        companyType: '',
        creditAmt: 0,
        address: '',
        email: ''
      }
    },
    handleCreate () {
      if (!getUserPermissions('COMPANY_ADD')) {
        this.$notify({
          title: '错误',
          message: '抱歉，你没有权限，请联系管理员开通',
          type: 'error'
        })
      } else {
        this.resetTemp()
        this.dialogStatus = 'create'
        this.selectLocation = ''
        this.dialogFormVisible = true
        this.loginNameStatus = false
        this.rules.loginName = [
          { required: true, message: '必须填写', trigger: 'blur' },
          {
            min: 2,
            max: 15,
            message: '长度在 2 到 15 个字符',
            trigger: 'blur'
          }
        ]
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
        })
      }
    },
    createData () {
      this.$refs['dataForm'].validate(valid => {
        if (valid) {
          createCompany(this.temp).then(res => {
            this.dialogFormVisible = false
            this.$notify({
              title: '成功',
              message: '创建成功',
              type: 'success',
              duration: 2000
            })
            this.getList()
          })
        }
      })
    },
    handleUpdate (row) {
      if (!getUserPermissions('COMPANY_EDIT')) {
        this.$notify({
          title: '错误',
          message: '抱歉，你没有权限，请联系管理员开通',
          type: 'error'
        })
      } else {
        this.selectLocation = ''
        this.temp = Object.assign({}, row) // copy obj
        this.temp.timestamp = new Date(this.temp.timestamp)
        this.dialogStatus = 'update'
        this.dialogFormVisible = true
        this.loginNameStatus = true
        this.rules.loginName = [
          { required: false, message: '必须填写', trigger: 'blur' },
          {
            min: 2,
            max: 15,
            message: '长度在 2 到 15 个字符',
            trigger: 'blur'
          }
        ]
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
        })
      }
    },
    updateData () {
      this.$refs['dataForm'].validate(valid => {
        if (valid) {
          const tempData = Object.assign({}, this.temp)
          tempData.timestamp = +new Date(tempData.timestamp)
          updateCompany(tempData).then(() => {
            for (const v of this.list) {
              if (v.id === this.temp.id) {
                const index = this.list.indexOf(v)
                this.list.splice(index, 1, this.temp)
                break
              }
            }
            this.dialogFormVisible = false
            this.$notify({
              title: '成功',
              message: '更新成功',
              type: 'success',
              duration: 2000
            })
            this.getList()
          })
        }
      })
    },
    changeDialogMemberVisible (val) {
      this.dialogMemberVisible = val
      this.getList()
    },
    handleChange (value) {
      this.selectLocation = ''
      this.temp.address = CodeToText[value[0]] + CodeToText[value[1]]
    },
    checkTransferMoney () {
      this.inputMoney1 = this.inputMoney1 ? this.inputMoney1 : 0
      this.inputMoney2 = this.inputMoney2 ? this.inputMoney2 : 0
      this.inputMoney3 = this.inputMoney3 ? this.inputMoney3 : 0
      const inputMoneyStr1 = this.inputMoney1
      const inputMoneyStr2 = this.inputMoney2
      const inputMoneyStr3 = this.inputMoney3
      let number1 = Number.parseFloat(inputMoneyStr1)
      console.log(number1 + 'inputMoneyStr1')
      this.inputMoney1 = number1 = Number.isNaN(number1)
        ? 0
        : number1 < 0
          ? 0
          : number1
      let number2 = Number.parseFloat(inputMoneyStr2)
      this.inputMoney2 = number2 = Number.isNaN(number2)
        ? 0
        : number2 < 0
          ? 0
          : number2
      let number3 = Number.parseFloat(inputMoneyStr3)
      this.inputMoney3 = number3 = Number.isNaN(number3)
        ? 0
        : number3 < 0
          ? 0
          : number3
      // 判断是不是小数，是小数就保留两位
      if (this.inputMoney1 !== Number.parseInt(this.inputMoney1)) {
        // this.inputMoney1 = Math.floor(this.inputMoney1 * 100) / 100;
        this.inputMoney1 = Number(this.inputMoney1 * 100) / 100
      }
      if (this.inputMoney2 !== Number.parseInt(this.inputMoney2)) {
        // this.inputMoney2 = Math.floor(this.inputMoney2 * 100) / 100;
        this.inputMoney2 = Number(this.inputMoney2 * 100) / 100
      }
      if (this.inputMoney3 !== Number.parseInt(this.inputMoney3)) {
        // this.inputMoney3 = Math.floor(this.inputMoney3 * 100) / 100;
        this.inputMoney3 = Number(this.inputMoney3 * 100) / 100
      }
      this.transferAmount =
        this.balanceAmt -
        (this.inputMoney1 + this.inputMoney2 + this.inputMoney3)
      this.transferModel.transferMoney = [
        this.inputMoney1,
        this.inputMoney2,
        this.inputMoney3
      ]
      // 验证输入
    },
    confirmTransfer () {
      this.transferLegal = true
      const inputMoneyArr = this.transferModel.transferMoney
      const childAccountArr = this.transferModel.childAccount
      if (this.transferAmount < 0) {
        this.showTips = true
        this.transferLegal = false
        return
      }
      if (inputMoneyArr.length === 0) {
        this.showTips = true
        this.transferLegal = false
        return
      }
      if (childAccountArr.length === 0) {
        this.showTips = true
        this.transferLegal = false
        return
      }
      // 不能三个子账户都为空
      let countChild = 0
      for (let i = 0; i < childAccountArr.length; i++) {
        if (!childAccountArr[i]) {
          countChild++
        }
        if (childAccountArr[i] && !inputMoneyArr[i]) {
          this.showTips = true
          this.transferLegal = false
        }
      }
      if (countChild >= 3) {
        this.showTips = true
        this.transferLegal = false
        return
      }
      // 三个子帐金额不能都为0
      let countMoney = 0
      for (let i = 0; i < inputMoneyArr.length; i++) {
        if (inputMoneyArr[i] === 0) {
          countMoney++
        }
      }
      if (countMoney >= 3) {
        this.showTips = true
        this.transferLegal = false
        return
      }
      if (!this.transferLegal) {
        // 请输入正确的信息
        this.showTips = true
        return
      }
      this.showTips = false
      const transferData = {
        masterAccount: this.transferModel.masterAccount,
        childAccount: childAccountArr,
        transferMoney: inputMoneyArr
      }
      const h = this.$createElement
      this.$msgbox({
        title: '提示',
        message: h('p', null, [
          h('span', null, '确定向子账户转账吗？'),
          h(
            'p',
            { style: 'color: teal' },
            '*没有选择子账户、金额为0将不会进行转账'
          )
        ]),
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        confirmButtonLoading: false,
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true
            instance.confirmButtonText = '执行中...'
            done()
            instance.confirmButtonLoading = false
            companyCharge(transferData).then(resp => {
              if (resp.data && resp.data.code === 0) {
                this.dialogTransfer = false
                this.getList()
                this.$notify({
                  title: '成功',
                  message: '转账成功',
                  type: 'success',
                  duration: 2000
                })
                done()
              }
            })
          } else {
            done()
          }
        }
      })
    },
    freshData (val) {
      if (val) {
        this.getList()
      }
    },
    bindChangeType () {
      this.temp.creditAmt = 0
    },
    // 透支额度权限
    overdrawAmtAuth () {
      console.log(getUserPermissions('OVERDRAW_SET'))
      if (!getUserPermissions('OVERDRAW_SET')) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>
